
/**
 * Created by anthony on 11/20/14.
 */
var applications = angular.module('applications', ['classy', 'applicationsSubNavbar', 'applicationSlider', 
    'rolloverWizard', 'awardCalculation', 'bin', 'putService', 'tabs', 'childrenModel', 'printableSummary', 'edit']);
